import { render, staticRenderFns } from "./VersionFamily.vue?vue&type=template&id=1731371c&"
import script from "./VersionFamily.vue?vue&type=script&lang=js&"
export * from "./VersionFamily.vue?vue&type=script&lang=js&"
import style0 from "./VersionFamily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports